import axiosClient from "utils/axios";
import { ApiList, ApiResponse } from "types/api.types";
import { ActivityLog, ActivityLogParams } from "../types/activity-log.types";

export const getActivityLogs = async (
  params: ActivityLogParams & { page: number; limit: number; search?: string },
) => {
  const { search: _search, ...rest } = params;
  const response = await axiosClient.get<ApiResponse<ApiList<ActivityLog[]>>>(
    "/activity-logs",
    {
      params: rest,
    },
  );

  return response.data;
};
